<div class="container-fluid">
  <footer class="footer">
    <div class="new_01">
      <div class="row g-0 it-0 col-md-12">
        <div class="footer-menu footer-menu-multiple col" (click)="toggleAccordion('navbarASupportedContent')">
          <div class="heading row">
            <h4 class=" head-style "> This Site <span class="dropdown-footer-button">
                <img src="../../../../assets/redesignImages/sli-buttonArrow.png" alt="footer-arc"></span></h4>
          </div>
          <div id="navbarASupportedContent" class="accordion-collapse">
            <ul aria-labelledby="ups-footer_thisSite" role="ulFooterTag"
              class=" nav-protect-packages me-auto mb-2 mb-lg-0">
              <li class="menu-transactional-insurance"><a href="/shipping-insurance">Shipping Insurance<span
                    class="nav_icon"></span></a></li>
              <li class="menu-flexible-parcel-insurance"><a href="/business-services">Business Services<span
                    class="nav_icon"></span></a></li>
              <li class="menu-flexible-parcel-insurance"><a href="/resources">Resources<span
                    class="nav_icon"></span></a></li>
              <li class="menu-transactional-insurance"><a href="/get-a-quote">Get
                  a Quote<span class="nav_icon"></span></a></li>
              <li class="menu-transactional-insurance"><a href="https://online-qa-app.azurewebsites.net/login"
                  target="_blank" rel="noopener">Log
                  In<span class="nav_icon"></span></a></li>

            </ul>

          </div>



        </div>
        <div class="footer-menu footer-menu-multiple col" (click)="toggleAccordion('navbarBSupportedContent')">
          <div class="heading row">
            <h4 class=" head-style"> Customer Service <span class="dropdown-footer-button">
                <img src="../../../../assets/redesignImages/sli-buttonArrow.png" alt="footer-arc"></span></h4>

          </div>

          <div id="navbarBSupportedContent" class="accordion-collapse">
            <ul class="nav-protect-packages">


              <li class="menu-flexible-parcel-insurance"><a href="/claims">Claims<span class="nav_icon"></span></a></li>
              <li class="menu-transactional-insurance"><a href="/about/help-and-support">Help
                  & Support<span class="nav_icon"></span></a></li>

              <li class="menu-flexible-parcel-insurance"><a href="/about/contact-us">Contact Us<span
                    class="nav_icon"></span></a></li>

            </ul>
          </div>

        </div>
        <div class="footer-menu footer-menu-multiple col " (click)="toggleAccordion('navbarCSupportedContent')">
          <div class="heading row">
            <h4 class=" head-style"> Company <span class="dropdown-footer-button">
                <img src="../../../../assets/redesignImages/sli-buttonArrow.png" alt="footer-arc"></span></h4>
          </div>
          <div id="navbarCSupportedContent" class="accordion-collapse">
            <ul class="nav-protect-packages">

              <li class="menu-transactional-insurance"><a href="/about">About Us<span class="nav_icon"></span></a></li>
              <li class="menu-flexible-parcel-insurance"><a href="/about/offices">Offices<span
                    class="nav_icon"></span></a></li>

            </ul>
          </div>
        </div>
        <div class="footer-menu footer-menu-multiple col" (click)="toggleAccordion('navbarDSupportedContent')">
          <div class="heading row">
            <h4 class="head-style">Other UPS Sites <span class="dropdown-footer-button">
                <img src="../../../../assets/redesignImages/sli-buttonArrow.png" alt="footer-arc"></span></h4>
          </div>
          <div id="navbarDSupportedContent" class="accordion-collapse">
            <ul class="nav-protect-packages">

              <li class="menu-transactional-insurance"><a href="https://www.parcelpro.com/us/en/home.html"
                  target="_blank" rel="noopener">Parcel Pro<span class="nav_icon">
                    <img src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a>
              </li>
              <li class="menu-flexible-parcel-insurance"><a href="https://www.insureshield.com/us/en/home.html"
                  target="_blank" rel="noopener">InsureShield <span class="nav_icon">
                    <img src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span><span
                    class="nav_icon"></span></a></li>
              <li class="menu-transactional-insurance"><a href="https://www.ups.com/us/en/Home.page" target="_blank"
                  rel="noopener">UPS<span class="nav_icon"> <img
                      src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a></li>
              <li class="menu-flexible-parcel-insurance"><a href="https://www.ups.com/us/en/supplychain/Home.page"
                  target="_blank" rel="noopener">UPS Supply Chain
                  Solutions<span class="nav_icon"> <img src="../../../../../assets/redesignImages/bgArcFooter.png"
                      alt="background-arc"></span></a></li>
              <li class="menu-transactional-insurance"><a href="https://about.ups.com/us/en/home.html" target="_blank"
                  rel="noopener">About UPS<span class="nav_icon">
                    <img src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a>
              </li>


            </ul>
          </div>



        </div>
        <div class="footer-menu footer-menu-multiple col" (click)="toggleAccordion('navbarESupportedContent')">
          <div class="heading row">
            <h4 class="head-style">Connect with Us <span class="dropdown-footer-button">
                <img src="../../../../assets/redesignImages/sli-buttonArrow.png" alt="footer-arc"></span></h4>
          </div>
          <div id="navbarESupportedContent" class="accordion-collapse">
            <ul class="nav-protect-packages">

              <li class="menu-transactional-insurance"><a href="https://twitter.com/upscapital" target="_blank"
                  rel="noopener">Twitter<span class="nav_icon"> <img
                      src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a></li>
              <li class="menu-flexible-parcel-insurance"><a href="https://www.linkedin.com/company/ups-capital"
                  target="_blank" rel="noopener">LinkedIn<span class="nav_icon">
                    <img src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a>
              </li>
              <li class="menu-transactional-insurance"><a href="https://www.youtube.com/@InsureShield" target="_blank"
                  rel="noopener">YouTube<span class="nav_icon"> <img
                      src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a></li>

            </ul>
          </div>

        </div>



        <div class="hidden-footer-content footer-menu footer-menu-multiple col"
          (click)="toggleAccordion('navbarLegalContent')">
          <div class="heading row">
            <h4 class="head-style">Legal <span class="dropdown-footer-button">
                <img src="../../../../assets/redesignImages/sli-buttonArrow.png" alt="footer-arc"></span></h4>
          </div>
          <div id="navbarLegalContent" class="accordion-collapse">
            <ul class="nav-protect-packages">

              <li class="menu-transactional-insurance"><a href="/technology-agreement/">Technology Agreement</a></li>
              <li class="menu-flexible-parcel-insurance"><a
                  href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page" target="_blank"
                  rel="noopener">Website Terms of Use<span class="nav_icon">
                    <img src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span></a>
              </li>
              <li class="menu-transactional-insurance"><a href="/us-product-disclosures/">Product Disclosure</a></li>
              <li class="menu-transactional-insurance"><a href="/product-terms-and-conditions/">Product Terms &
                  Conditions</a></li>
              <li class="menu-flexible-parcel-insurance"><a
                  href="/california-privacy-notice"
                  rel="noopener">Your California Privacy Rights</a>
              </li>
              <li class="menu-transactional-insurance"><a href="/privacy-notice/">Privacy Notice</a></li>
              <li class="menu-transactional-insurance"><a (click)="openConsentPreferences($event)" role="button" tabindex="0">Cookie Settings</a></li>
              <li class="menu-flexible-parcel-insurance"><a href="/opt-out" rel="noopener">Do Not Sell or Share My
                  Personal Information</a></li>

            </ul>
          </div>

        </div>


      </div>

      <div class=" bott-cap">
        <div class="col-sm-12 Website-Terms-of-Use mar-line">
          <a id="cookie-consent" href="/technology-agreement/">Technology Agreement </a>&nbsp;<span class="layer"> |
          </span>&nbsp;
          <a id="cookie-consent" href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page"
            target="_blank" rel="noopener"> Website Terms of Use &nbsp;<span class="nav_icon">
              <img src="../../../../../assets/redesignImages/bgArcFooter.png" alt="background-arc"></span>
          </a>
          &nbsp;
          <span class="layer" href="#"> |</span>&nbsp;
          <a id="cookie-consent" href="/us-product-disclosures/">Product Disclosure
          </a> &nbsp;<span class="layer">|</span>&nbsp;
          <a id="cookie-consent" href="/product-terms-and-conditions/">Product Terms & Conditions
          </a> &nbsp;<span class="layer">|</span>&nbsp;
          <a id="cookie-consent"
            href="/california-privacy-notice"
             rel="noopener">Your California Privacy Rights
          </a>&nbsp; <span class="layer">|</span>&nbsp;
          <a id="cookie-consent" href="/privacy-notice/">Privacy Notice
          </a> &nbsp;<span class="layer">|</span>&nbsp;
          <a id="cookie-consent" href="javascript:window.OneTrust.ToggleInfoDisplay();window.scrollTo(0,0);"
role="button" tabindex="0">Cookie
            Settings
          </a> &nbsp;<span class="layer">|</span>&nbsp;<br>
          <a id="cookie-consent" href="/opt-out" rel="noopener">Do Not Sell or Share My Personal Information&nbsp;
          </a>
        </div>
        <div class="col-sm-12 Website-Terms-of-Use legal-ch">
          <span class="layer"> Copyright ©2015 - {{ currentYear }} United Parcel Service of America, Inc. All rights reserved.
          </span>
        </div>
      </div>

    </div>
  </footer>
</div>